
import { Document, Page, Text, View, Image, StyleSheet, Font } from "@react-pdf/renderer";
import Collab from '../../../Assets/Images/user-logos/collab.png'
import Heart from '../../../Assets/Images/user-logos/heart.png'
import Mind from '../../../Assets/Images/user-logos/mind.png'
import Perform from '../../../Assets/Images/user-logos/perform.png'
import Soul from '../../../Assets/Images/user-logos/soul.png'
import Strategy from '../../../Assets/Images/user-logos/strategy.png'
import Strength from '../../../Assets/Images/user-logos/strength.png'
import vision from '../../../Assets/Images/user-logos/vision.png'

const LeadItemTwoOverview = () => {

  const styles = StyleSheet.create({
    pagewapper: {
      position: "relative",
      height: "100%"
  },
  page: {
    paddingHorizontal: 21,
    paddingVertical: 30,
    backgroundColor: '#FFFFFF',
    justifyContent: "space-between",
    height: '100%'
  },
  content: {
      // marginTop: "35px",
      display: "flex",
      width: "570px",
      alignItems: "left"
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottom: '1px solid #00577D',
    paddingBottom: 5,
    marginBottom: 2,
    marginTop: '-15px'
  },
  titlemain: {
    fontSize: 12,
    fontWeight: 700,
    color: '#76A3BE',
  },
  title: {
    fontSize: 11,
    fontWeight: 200,
    color: '#76A3BE',
  },
  rightsection: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    flex: 1,
  },
  rightText: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
  rightTextsybtext: {
    fontSize: 8,
    textAlign: 'right',
    fontWeight: 700,
    color: '#76A3BE',
  },
    contenttitle: {
      fontFamily: "Lato",
      fontWeight: 700,
      fontSize: "18px",
      lineHeight: "30px",
      color: "#426B88"
  },
  headertext: {
    fontSize: 16,
    fontWeight: 700,
    color: '#245775',
    marginLeft: 0,
    paddingLeft: 0,
    marginTop: 12,
    marginBottom: 12
  },
  paragraph: {
    fontSize: 12,
    textAlign: 'justify',
    fontWeight: 400,
    color: '#245775',
    marginBottom: 5,
    fontFamily: 'Lato',
    lineHeight: '18px',
  },
  wapper: {
      width: "567px",
      fontFamily: "Lato",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "18px",
      color: "#245775"
    },
    mainContent: {
        marginTop:"14px",
  },
  footer: {
      marginTop: 'auto',
  },
  table: {
      width: '100%',
      // borderWidth: 1,
      // borderColor: '#ccc',
  },
  tableRow: {
      flexDirection: 'row',
  },
    tableHeader: {
      paddingVertical: 1,
      fontWeight: 400,
      border:'0px',
      backgroundColor: '#245775',
      fontWeight: 'bold',
      color: 'white',
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
  headerCell:{color: 'white', fontSize: 10.05, fontWeight:400, paddingVertical:"5px"},
  // cellQuestion: { width: '70%', fontSize: 10,color:"#394554", fontWeight:400},
  // cellScore: { width: '7%', textAlign: 'center', fontSize: 10 },
  cell: {
      padding: "8.3px 4px",
      textAlign: "left",
    },
    
    rowEven: {
      backgroundColor: "#F1F3F3",
    },
    rowOdd: {
      backgroundColor: "#FFF",
    },
    footer: {
      width: 540,
      borderTop: '1px solid #00577D',
      paddingTop: 5,
      flexDirection: 'row',
      justifyContent: 'space-between',
      position: 'absolute',
      bottom: 15,
      left: 10,
      right: 21,
    },
    footersection: {
      flexDirection: 'column'
    },
    footerTextheading: {
      fontSize: 10,
      fontWeight: 700,
      fontFamily: 'Lato',
      color: '#76A3BE',
    },
    footerText: {
      fontSize: 8,
      fontFamily: 'Lato',
      fontWeight: 400,
      color: '#76A3BE',
    },
    cellNumber: { width: '5%', textAlign: 'center', fontSize: 8, color:"#394554", fontWeight:400 },
    cellQuadrant: { width: '20%', fontSize: 8, color:"#394554", fontWeight:400 },
    cellQuestion: { width: '60%', fontSize: 8, color:"#394554", fontWeight:400 },
    cellScore: { width: '15%', textAlign: 'center', fontSize: 8, fontWeight: 700 },  
    logoimage : { flexDirection: 'row' },
    logos:  { height: 13.66, width: 13.66, position: 'absolute', right: 5 },
    logoWrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      position: 'relative'
    },
    });

    const data = [
      { "quadrant": "PERFORMANCE", "img": Perform, "question": "I am motivated to push my team to win", "score": 4 },
      { "quadrant": "COLLABORATIVE", "img": Collab, "question": "I am motivated to help my team connect more deeply with each other.", "score": 4 },
      { "quadrant": "STRATEGIC", "img": Strategy, "question": "I believe the best way to achieve effectiveness is through good policies.", "score": 4 },
      { "quadrant": "STRATEGIC", "img": Strategy, "question": "I believe strategic thinking is the main contributor of success. ", "score": 4 },
      { "quadrant": "PERFORMANCE", "img": Perform, "question": " I have found success by outworking other people.", "score": 4 },
      { "quadrant": "COLLABORATIVE", "img": Collab, "question": "I find fulfillment in developing a collaborative leadership culture. ", "score": 4 },
      { "quadrant": "VISIONARY", "img": vision, "question": "I believe success is contingent on having a clear vision.", "score": 4 },
      { "quadrant": "COLLABORATIVE", "img": Collab, "question": "I develop others by first getting buy-in on our shared values.", "score": 4 },
      { "quadrant": "VISIONARY", "img": vision, "question": "My superpower is to see the “why” behind the “what” or the “how.”", "score": 4 },
      { "quadrant": "PERFORMANCE", "img": Perform, "question": "I consider myself an action orientated manager who can drive objectives.", "score": 4 },
      { "quadrant": "STRATEGIC", "img": Strategy, "question": " I intentionally develop others by educating them on what they need to know.", "score": 4 },
      { "quadrant": "PERFORMANCE", "img": Perform, "question": "I pride myself on superior execution.", "score": 4 },
      { "quadrant": "COLLABORATIVE", "img": Collab, "question": "I enjoy building an empowering culture at work.", "score": 4 },
      { "quadrant": "VISIONARY", "img": vision, "question": "I can weave a powerful narrative that unites people for a common purpose.", "score": 4 },
      { "quadrant": "STRATEGIC", "img": Strategy, "question": "I believe success is contingent on thinking smarter.", "score": 4 },
      { "quadrant": "STRATEGIC", "img": Strategy, "question": "I find great satisfaction in developing effective strategies for our organization.", "score": 4 },
      { "quadrant": "COLLABORATIVE", "img": Collab, "question": "I want our people to be fully engaged in the decision-making process.", "score": 4 },
      { "quadrant": "PERFORMANCE", "img": Perform, "question": "I like to win in a competitive environment.", "score": 4 },
      { "quadrant": "VISIONARY", "img": vision, "question": "I can usually see what lies ahead in the future of our organization.", "score": 4 },
    ]

    return (
      <View style={styles.page}>
        <View>
          {/* Header */}
          <View style={styles.header}>
            <View style={styles.headerleft}>
              <Text style={styles.titlemain}>QUADRANT FLOW</Text>
              <Text style={styles.title}>Life & Leadership Assssment</Text>
            </View>
            <View style={styles.rightsection}>
              <Text style={styles.rightText}>Rob Murray</Text>
              <Text style={styles.rightTextsybtext}>Atlas Real Estate{"\n"}Oct 18, 2024</Text>
            </View>
          </View>
  
          <View style={styles.container}>
            <View style={styles.containersection}>
              <Text style={styles.headertext}>LEADERSHIP ITEMS OVERVIEW</Text>
            </View>
          </View> 
  
          {/* Content */}
          <View style={styles.mainContent}>
            <View style={styles.tableRow}>
              <View style={[styles.tableRow, styles.tableHeader]}>
                <Text style={[styles.cell, styles.cellNumber, styles.headerCell]}>#</Text>
                <Text style={[styles.cell, styles.cellQuadrant, styles.headerCell]}>Quadrant</Text>
                <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Question</Text>
                <Text style={[styles.cell, styles.cellScore, styles.headerCell]}>Score</Text>
              </View>
            </View>
            {data.map((item, index) => (
              <View style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]} key={index}>
                <Text style={[styles.cell, styles.cellNumber]}>{index + 22}</Text>
                <View style={[styles.cell, styles.logoWrapper]}>
                  <Text style={[styles.cellQuadrant]}>{item.quadrant}</Text>
                  <Image src={item.img} style={styles.logos} />
                </View>
                <Text style={[styles.cell, styles.cellQuestion]}>{item.question}</Text>
                <Text style={[styles.cell, styles.cellScore]}>{item.score}</Text>
              </View>
            ))}
          </View>
            {/* <Image src={FlowTwo} style={styles.flowimg} /> */}
        </View>
        
        {/* Footer Section */}
        <View style={styles.footer}>
          <View style={styles.footersection}>
            <Text style={styles.footerTextheading}>SELF REPORT</Text>
            <Text style={styles.footerText}>© Copyright 2025 by Dr. Rob Murray & Jack Nicholson. Published by Transformational Performance & Transformed Leader. All rights reserved.</Text>
          </View>
          <Text style={styles.footerTextheading}>PAGE</Text>
        </View>
      </View>
    );
}

export default LeadItemTwoOverview;